import { i18n } from '@/utils/i18n';
export const columns2 = {
    patient_id: {
        show: true,
        title: i18n.t('message.patient'),
        sortable: true,
        column: 'patient_id'
    },
    total_price: {
        show: true,
        title: i18n.t('message.total_amount'),
        sortable: true,
        column: 'total_price'
    },
    order_id: {
        show: true,
        title: i18n.t('message.order_id'),
        sortable: true,
        column: 'order_id'
    },
    service: {
        show: true,
        title: i18n.t('message.service'),
        sortable: true,
        column: 'service'
    },
    paid_price: {
        show: true,
        title: i18n.t('message.paid'),
        sortable: false,
        column: 'paid_price'
    },
    color: {
        show: true,
        title: i18n.t('message.color'),
        sortable: false,
        column: 'color',
        printable: false
    },
    doctor_id: {
        show: true,
        title: i18n.t('message.doctor_0'),
        sortable: true,
        column: 'doctor_id'
    },
    created_at: {
        show: true,
        title:  i18n.t('message.date'),
        sortable: true,
        column: 'created_at',
    },
    hour: {
        show: true,
        title:  i18n.t('message.hour'),
        sortable: true,
        column: 'hour',
    },
};